export default "__VITE_ASSET__Dcl2G5o2__"